import React from "react";
import { BarChart3 } from "lucide-react";

export const HoldingsComparisonHeader = () => {
  return (
    <div className="flex items-center justify-between  px-4 ">
      <div className="flex items-center">
        <BarChart3 className="h-6 w-6 mr-2 text-primary" />
        <h1 className="text-3xl font-bold">Holdings Comparison</h1>
      </div>
      <p className="text-muted-foreground">
        Compare holdings across different reporting periods
      </p>
    </div>
  );
}; 